// API Endpoints Data - Generated from real backend routes
// Base URL: https://api.signtada.com

const APIEndpoints = {
  auth: {
    title: 'Authentication',
    description: 'User authentication, registration, and token management endpoints.',
    endpoints: [
      {
        method: 'POST',
        path: '/auth/register',
        description: 'Register a new user account. First user becomes SUPER_ADMIN. Subsequent users require admin authentication.',
        auth: 'Public endpoint. For non-first users, requires Bearer token from admin.',
        requestBody: {
          email: 'user@example.com',
          password: 'securepassword123',
          roles: ['USER'],
          companyId: '507f1f77bcf86cd799439011' // Optional, required for non-super-admin users
        },
        requestBodySchema: {
          email: {
            type: 'string',
            required: true,
            description: 'User email address (will be lowercased)'
          },
          password: {
            type: 'string',
            required: true,
            description: 'User password'
          },
          roles: {
            type: 'array<string>',
            required: false,
            description: 'User roles. Default: ["USER"]. Options: USER, ADMIN, SUPER_ADMIN'
          },
          companyId: {
            type: 'string (ObjectId)',
            required: false,
            description: 'Company ID to assign user to (required for non-super-admin users)'
          }
        },
        response: {
          message: 'User registered successfully',
          user: {
            id: '507f1f77bcf86cd799439011',
            email: 'user@example.com',
            roles: ['USER'],
            companyId: '507f1f77bcf86cd799439011'
          },
          accessToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...',
          refreshToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...'
        },
        example: `curl -X POST https://api.signtada.com/auth/register \\
  -H "Content-Type: application/json" \\
  -d '{
    "email": "user@example.com",
    "password": "securepassword123",
    "roles": ["USER"],
    "companyId": "507f1f77bcf86cd799439011"
  }'`,
        exampleJS: `const response = await fetch('https://api.signtada.com/auth/register', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer <admin_token>' // Required for non-first user
  },
  body: JSON.stringify({
    email: 'user@example.com',
    password: 'securepassword123',
    roles: ['USER'],
    companyId: '507f1f77bcf86cd799439011'
  })
});
const data = await response.json();`,
        errors: [
          {
            status: 400,
            message: 'Email and password are required',
            description: 'Missing required fields'
          },
          {
            status: 400,
            message: 'Email already registered',
            description: 'Email is already in use'
          },
          {
            status: 401,
            message: 'Registration is restricted. Please login as Admin.',
            description: 'Attempting to register without admin token (for non-first user)'
          }
        ]
      },
      {
        method: 'POST',
        path: '/auth/login',
        description: 'Authenticate user with email and password. Returns JWT access and refresh tokens.',
        auth: 'Public endpoint',
        requestBody: {
          email: 'user@example.com',
          password: 'securepassword123'
        },
        requestBodySchema: {
          email: {
            type: 'string',
            required: true,
            description: 'User email address'
          },
          password: {
            type: 'string',
            required: true,
            description: 'User password'
          }
        },
        response: {
          message: 'Login successful',
          user: {
            id: '507f1f77bcf86cd799439011',
            email: 'user@example.com',
            roles: ['USER'],
            companyId: '507f1f77bcf86cd799439011'
          },
          accessToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...',
          refreshToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...'
        },
        example: `curl -X POST https://api.signtada.com/auth/login \\
  -H "Content-Type: application/json" \\
  -d '{
    "email": "user@example.com",
    "password": "securepassword123"
  }'`,
        exampleJS: `const response = await fetch('https://api.signtada.com/auth/login', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({
    email: 'user@example.com',
    password: 'securepassword123'
  })
});
const data = await response.json();
localStorage.setItem('authToken', data.accessToken);
localStorage.setItem('refreshToken', data.refreshToken);`,
        errors: [
          {
            status: 400,
            message: 'Email and password are required',
            description: 'Missing required fields'
          },
          {
            status: 401,
            message: 'Invalid email or password',
            description: 'Invalid credentials'
          },
          {
            status: 403,
            message: 'User is inactive',
            description: 'User account has been deactivated'
          }
        ]
      },
      {
        method: 'POST',
        path: '/auth/google-login',
        description: 'Authenticate user with Google SSO. User must be pre-registered in the system.',
        auth: 'Public endpoint',
        requestBody: {
          token: 'GOOGLE_ID_TOKEN'
        },
        requestBodySchema: {
          token: {
            type: 'string',
            required: true,
            description: 'Google ID token from OAuth flow'
          }
        },
        response: {
          message: 'Google Login successful',
          user: {
            id: '507f1f77bcf86cd799439011',
            email: 'user@example.com',
            roles: ['USER'],
            companyId: '507f1f77bcf86cd799439011'
          },
          accessToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...',
          refreshToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...'
        },
        example: `curl -X POST https://api.signtada.com/auth/google-login \\
  -H "Content-Type: application/json" \\
  -d '{
    "token": "GOOGLE_ID_TOKEN"
  }'`,
        errors: [
          {
            status: 400,
            message: 'Token is required',
            description: 'Missing Google token'
          },
          {
            status: 401,
            message: 'Invalid Google Token',
            description: 'Token verification failed'
          },
          {
            status: 403,
            message: 'User is not registered. Please contact admin.',
            description: 'Email not found in database'
          }
        ]
      },
      {
        method: 'POST',
        path: '/auth/refresh',
        description: 'Refresh access token using refresh token. Returns new access and refresh token pair.',
        auth: 'Protected - Requires refresh token in body',
        requestBody: {
          refreshToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...'
        },
        requestBodySchema: {
          refreshToken: {
            type: 'string',
            required: true,
            description: 'Valid refresh token'
          }
        },
        response: {
          accessToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...',
          refreshToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...'
        },
        example: `curl -X POST https://api.signtada.com/auth/refresh \\
  -H "Content-Type: application/json" \\
  -d '{
    "refreshToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..."
  }'`,
        errors: [
          {
            status: 400,
            message: 'refreshToken is required',
            description: 'Missing refresh token'
          },
          {
            status: 401,
            message: 'Token expired',
            description: 'Refresh token has expired'
          },
          {
            status: 401,
            message: 'Refresh token revoked',
            description: 'Token has been revoked'
          }
        ]
      },
      {
        method: 'POST',
        path: '/auth/logout',
        description: 'Logout user and revoke refresh token.',
        auth: 'Protected - Requires Bearer token',
        headers: [
          {
            name: 'Authorization',
            type: 'string',
            required: true,
            description: 'Bearer token: Bearer <access_token>'
          }
        ],
        requestBody: {
          refreshToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...' // Optional
        },
        response: {
          message: 'Logged out'
        },
        example: `curl -X POST https://api.signtada.com/auth/logout \\
  -H "Authorization: Bearer <access_token>" \\
  -H "Content-Type: application/json" \\
  -d '{
    "refreshToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..."
  }'`,
        errors: [
          {
            status: 401,
            message: 'Authorization header missing or invalid',
            description: 'Missing or invalid Bearer token'
          }
        ]
      },
      {
        method: 'GET',
        path: '/auth/me',
        description: 'Get current authenticated user information including credits.',
        auth: 'Protected - Requires Bearer token',
        headers: [
          {
            name: 'Authorization',
            type: 'string',
            required: true,
            description: 'Bearer token: Bearer <access_token>'
          }
        ],
        response: {
          user: {
            id: '507f1f77bcf86cd799439011',
            email: 'user@example.com',
            roles: ['USER'],
            companyId: '507f1f77bcf86cd799439011',
            envelope_quota: 100,
            credits: 10.0
          }
        },
        example: `curl -X GET https://api.signtada.com/auth/me \\
  -H "Authorization: Bearer <access_token>"`,
        exampleJS: `const response = await fetch('https://api.signtada.com/auth/me', {
  method: 'GET',
  headers: {
    'Authorization': 'Bearer ' + localStorage.getItem('authToken')
  }
});
const data = await response.json();`,
        errors: [
          {
            status: 401,
            message: 'Authorization header missing or invalid',
            description: 'Missing or invalid Bearer token'
          },
          {
            status: 404,
            message: 'User not found',
            description: 'User does not exist'
          }
        ]
      }
    ]
  },
  // Continue with other sections...
  requests: {
    title: 'Document Requests',
    description: 'Create and manage document signing requests.',
    endpoints: [
      {
        method: 'POST',
        path: '/requests/create_request',
        description: 'Create a new document signing request. Supports both direct file upload and template-based requests.',
        auth: 'Protected - Requires Bearer token or X-API-Key',
        headers: [
          {
            name: 'Authorization',
            type: 'string',
            required: false,
            description: 'Bearer token: Bearer <access_token> (for user auth)'
          },
          {
            name: 'X-API-Key',
            type: 'string',
            required: false,
            description: 'API key: sk_live_<key> (for API key auth)'
          },
          {
            name: 'Content-Type',
            type: 'string',
            required: true,
            description: 'application/json or multipart/form-data'
          }
        ],
        requestBody: {
          recipients: [
            {
              name: 'John Doe',
              email: 'john@example.com',
              phone: '+1234567890',
              signature_type: 'e-signature',
              role_labels: ['Signer 1']
            }
          ],
          file_path: 'uploads/document_20240101_120000.pdf', // For JSON
          // OR use multipart/form-data with 'file' field
          template_id: '507f1f77bcf86cd799439011', // Optional, for template-based
          field_values: { // For template-based requests
            'Client Name': 'John Doe',
            'Date': '2024-01-01'
          },
          sigPositions: { // For manual placement
            '1': {
              'john@example.com': { x: 100, y: 200 }
            }
          },
          selected_pages: [1],
          apply_all_pages: false,
          rendered_page_width: 500,
          document_name: 'Contract Agreement',
          security_settings: {
            email_notification_enabled: true,
            otp_enabled: false,
            capture_location: false,
            capture_face: false,
            enable_reminder: false,
            reminder_duration: '24',
            enable_expiry: false,
            expiry_date: ''
          },
          orgId: '507f1f77bcf86cd799439011' // Optional, Super Admin only
        },
        response: {
          message: 'Request created successfully',
          reference_id: 'ABC12345'
        },
        example: `curl -X POST https://api.signtada.com/requests/create_request \\
  -H "Authorization: Bearer <access_token>" \\
  -H "Content-Type: application/json" \\
  -d '{
    "recipients": [{
      "name": "John Doe",
      "email": "john@example.com",
      "phone": "+1234567890",
      "signature_type": "e-signature",
      "role_labels": ["Signer 1"]
    }],
    "file_path": "uploads/document_20240101_120000.pdf",
    "document_name": "Contract Agreement",
    "security_settings": {
      "email_notification_enabled": true
    }
  }'`,
        errors: [
          {
            status: 400,
            message: 'Invalid recipients format',
            description: 'recipients must be an array'
          },
          {
            status: 400,
            message: 'No file provided',
            description: 'Missing file_path or file upload'
          },
          {
            status: 401,
            message: 'Authorization header missing or invalid',
            description: 'Missing or invalid authentication'
          },
          {
            status: 404,
            message: 'Template not found',
            description: 'Template ID does not exist'
          }
        ]
      },
      {
        method: 'GET',
        path: '/requests/list_requests',
        description: 'List all document requests with pagination and filtering.',
        auth: 'Protected - Requires Bearer token',
        queryParams: [
          {
            name: 'page',
            type: 'integer',
            required: false,
            description: 'Page number (default: 1)'
          },
          {
            name: 'per_page',
            type: 'integer',
            required: false,
            description: 'Items per page (default: 10)'
          },
          {
            name: 'orgId',
            type: 'string',
            required: false,
            description: 'Filter by organization ID (Super Admin only)'
          },
          {
            name: 'date_from',
            type: 'string (ISO)',
            required: false,
            description: 'Filter from date (ISO format)'
          },
          {
            name: 'date_to',
            type: 'string (ISO)',
            required: false,
            description: 'Filter to date (ISO format)'
          }
        ],
        response: {
          data: [
            {
              _id: '507f1f77bcf86cd799439011',
              reference_id: 'ABC12345',
              document_name: 'Contract Agreement',
              status: 'Pending',
              created_at: '2024-01-01T12:00:00.000Z',
              recipients: [
                {
                  name: 'John Doe',
                  email: 'john@example.com',
                  status: 'Pending'
                }
              ]
            }
          ],
          total: 100,
          page: 1,
          per_page: 10
        },
        example: `curl -X GET "https://api.signtada.com/requests/list_requests?page=1&per_page=10" \\
  -H "Authorization: Bearer <access_token>"`,
        errors: [
          {
            status: 401,
            message: 'Authorization header missing or invalid',
            description: 'Missing or invalid Bearer token'
          }
        ]
      },
      {
        method: 'GET',
        path: '/requests/get_document_by_reference/<reference_id>',
        description: 'Get document details by reference ID. Public endpoint, no authentication required.',
        auth: 'Public endpoint',
        response: {
          reference_id: 'ABC12345',
          document_name: 'Contract Agreement',
          status: 'Pending',
          created_at: '2024-01-01T12:00:00.000Z',
          recipients: []
        },
        example: `curl -X GET https://api.signtada.com/requests/get_document_by_reference/ABC12345`,
        errors: [
          {
            status: 404,
            message: 'Document not found',
            description: 'Reference ID does not exist'
          }
        ]
      },
      {
        method: 'GET',
        path: '/requests/stats',
        description: 'Get aggregated statistics for dashboard.',
        auth: 'Protected - Requires Bearer token',
        queryParams: [
          {
            name: 'orgId',
            type: 'string',
            required: false,
            description: 'Filter by organization ID (Super Admin only)'
          },
          {
            name: 'date_from',
            type: 'string (ISO)',
            required: false,
            description: 'Filter from date'
          },
          {
            name: 'date_to',
            type: 'string (ISO)',
            required: false,
            description: 'Filter to date'
          }
        ],
        response: {
          total: 100,
          signed: 75,
          pending: 25,
          rejected: 5,
          completion_rate: '75%',
          templates_used: 30,
          templates_used_percentage: 30
        },
        example: `curl -X GET "https://api.signtada.com/requests/stats?date_from=2024-01-01&date_to=2024-01-31" \\
  -H "Authorization: Bearer <access_token>"`
      },
      {
        method: 'GET',
        path: '/requests/top_recipients',
        description: 'Get top recipients who have signed the most documents. Used for dashboard widgets.',
        auth: 'Protected - Requires Bearer token',
        queryParams: [
          {
            name: 'limit',
            type: 'integer',
            required: false,
            description: 'Max number of recipients to return (default: 5)'
          },
          {
            name: 'orgId',
            type: 'string',
            required: false,
            description: 'Filter by organization ID (Super Admin only)'
          }
        ],
        response: {
          recipients: [
            {
              _id: { email: 'john@example.com', name: 'John Doe' },
              count: 12
            }
          ]
        },
        example: `curl -X GET "https://api.signtada.com/requests/top_recipients?limit=5" \\
  -H "Authorization: Bearer <access_token>"`
      },
      {
        method: 'GET',
        path: '/requests/recent_activity',
        description: 'Get recent activity feed for dashboard (request created, document signed, rejected, template created).',
        auth: 'Protected - Requires Bearer token',
        queryParams: [
          {
            name: 'limit',
            type: 'integer',
            required: false,
            description: 'Max number of activities (default: 6)'
          },
          {
            name: 'orgId',
            type: 'string',
            required: false,
            description: 'Filter by organization ID (Super Admin only)'
          }
        ],
        response: {
          activities: [
            {
              type: 'document_signed',
              icon: 'check',
              description: 'Document signed',
              actor: 'John Doe',
              reference_id: 'ABC12345',
              document_name: 'Contract',
              timestamp: '2024-01-01T12:00:00.000Z'
            }
          ]
        },
        example: `curl -X GET "https://api.signtada.com/requests/recent_activity?limit=6" \\
  -H "Authorization: Bearer <access_token>"`
      }
    ]
  },
  templates: {
    title: 'Templates',
    description: 'Manage reusable document templates with predefined signature positions and text fields.',
    endpoints: [
      {
        method: 'POST',
        path: '/templates/create',
        description: 'Create a new document template.',
        auth: 'Protected - Requires Bearer token',
        requestBody: {
          title: 'NDA Template',
          file_path: 'uploads/template_20240101.pdf',
          roles: [
            {
              label: 'Client',
              page: 1,
              x: 100,
              y: 200
            }
          ],
          text_fields: [
            {
              label: 'Client Name',
              page: 1,
              x: 50,
              y: 150
            }
          ]
        },
        response: {
          message: 'Template created successfully',
          template_id: '507f1f77bcf86cd799439011'
        },
        example: `curl -X POST https://api.signtada.com/templates/create \\
  -H "Authorization: Bearer <access_token>" \\
  -H "Content-Type: application/json" \\
  -d '{
    "title": "NDA Template",
    "file_path": "uploads/template_20240101.pdf",
    "roles": [{"label": "Client", "page": 1, "x": 100, "y": 200}],
    "text_fields": [{"label": "Client Name", "page": 1, "x": 50, "y": 150}]
  }'`
      },
      {
        method: 'GET',
        path: '/templates/list',
        description: 'List all active templates for the user\'s organization.',
        auth: 'Protected - Requires Bearer token',
        response: [
          {
            _id: '507f1f77bcf86cd799439011',
            title: 'NDA Template',
            created_at: '2024-01-01T12:00:00.000Z',
            created_by: 'user@example.com'
          }
        ],
        example: `curl -X GET https://api.signtada.com/templates/list \\
  -H "Authorization: Bearer <access_token>"`
      },
      {
        method: 'GET',
        path: '/templates/<template_id>',
        description: 'Get template details by ID.',
        auth: 'Protected - Requires Bearer token',
        response: {
          _id: '507f1f77bcf86cd799439011',
          title: 'NDA Template',
          file_path: 'uploads/template_20240101.pdf',
          roles: [],
          text_fields: []
        },
        example: `curl -X GET https://api.signtada.com/templates/507f1f77bcf86cd799439011 \\
  -H "Authorization: Bearer <access_token>"`
      },
      {
        method: 'PUT',
        path: '/templates/<template_id>',
        description: 'Update an existing template.',
        auth: 'Protected - Requires Bearer token',
        requestBody: {
          title: 'Updated NDA Template',
          roles: [],
          text_fields: []
        },
        response: {
          _id: '507f1f77bcf86cd799439011',
          title: 'Updated NDA Template',
          updated_at: '2024-01-02T12:00:00.000Z'
        },
        example: `curl -X PUT https://api.signtada.com/templates/507f1f77bcf86cd799439011 \\
  -H "Authorization: Bearer <access_token>" \\
  -H "Content-Type: application/json" \\
  -d '{"title": "Updated NDA Template"}'`
      },
      {
        method: 'DELETE',
        path: '/templates/<template_id>',
        description: 'Soft delete a template (sets is_active to false).',
        auth: 'Protected - Requires Bearer token',
        response: {
          message: 'Template deleted'
        },
        example: `curl -X DELETE https://api.signtada.com/templates/507f1f77bcf86cd799439011 \\
  -H "Authorization: Bearer <access_token>"`
      }
    ]
  },
  webhooks: {
    title: 'Webhooks',
    description: 'Configure and manage webhooks for real-time event notifications.',
    endpoints: [
      {
        method: 'GET',
        path: '/webhooks',
        description: 'Get webhook configuration for the current user\'s company.',
        auth: 'Protected - Requires Bearer token',
        response: {
          url: 'https://your-api.com/webhook',
          headers: {
            'Authorization': 'Bearer your-secret-key'
          },
          is_active: true
        },
        example: `curl -X GET https://api.signtada.com/webhooks \\
  -H "Authorization: Bearer <access_token>"`
      },
      {
        method: 'POST',
        path: '/webhooks',
        description: 'Update webhook configuration.',
        auth: 'Protected - Requires Bearer token',
        requestBody: {
          url: 'https://your-api.com/webhook',
          headers: {
            'Authorization': 'Bearer your-secret-key'
          },
          is_active: true
        },
        response: {
          message: 'Webhook configuration saved'
        },
        example: `curl -X POST https://api.signtada.com/webhooks \\
  -H "Authorization: Bearer <access_token>" \\
  -H "Content-Type: application/json" \\
  -d '{
    "url": "https://your-api.com/webhook",
    "headers": {"Authorization": "Bearer your-secret-key"},
    "is_active": true
  }'`
      },
      {
        method: 'GET',
        path: '/webhooks/logs',
        description: 'Get webhook delivery logs.',
        auth: 'Protected - Requires Bearer token',
        response: [
          {
            _id: '507f1f77bcf86cd799439011',
            event_type: 'request.created',
            response_status: 200,
            timestamp: '2024-01-01T12:00:00.000Z',
            payload: {
              data: {
                reference_id: 'ABC12345'
              }
            }
          }
        ],
        example: `curl -X GET https://api.signtada.com/webhooks/logs \\
  -H "Authorization: Bearer <access_token>"`
      },
      {
        method: 'POST',
        path: '/webhooks/resend',
        description: 'Resend a webhook payload. Rate limited to once per 10 minutes per reference ID.',
        auth: 'Protected - Requires Bearer token',
        requestBody: {
          log_id: '507f1f77bcf86cd799439011'
        },
        response: {
          message: 'Webhook resent successfully'
        },
        example: `curl -X POST https://api.signtada.com/webhooks/resend \\
  -H "Authorization: Bearer <access_token>" \\
  -H "Content-Type: application/json" \\
  -d '{"log_id": "507f1f77bcf86cd799439011"}'`,
        errors: [
          {
            status: 429,
            message: 'Rate limit: You can only resend this document\'s webhook once every 10 minutes.',
            description: 'Too many resend attempts'
          }
        ]
      }
    ]
  },
  files: {
    title: 'Files',
    description: 'Upload and manage files.',
    endpoints: [
      {
        method: 'POST',
        path: '/files/upload',
        description: 'Upload a file to cloud storage. Returns file path and signed URL.',
        auth: 'Protected - Requires Bearer token',
        headers: [
          {
            name: 'Content-Type',
            type: 'string',
            required: true,
            description: 'multipart/form-data'
          }
        ],
        requestBody: {
          file: '<binary file data>'
        },
        response: {
          message: 'File uploaded successfully',
          file_path: 'uploads/document_20240101_120000.pdf',
          public_url: 'https://storage.googleapis.com/...'
        },
        example: `curl -X POST https://api.signtada.com/files/upload \\
  -H "Authorization: Bearer <access_token>" \\
  -F "file=@document.pdf"`
      },
      {
        method: 'GET',
        path: '/files/uploads/<filename>',
        description: 'Get a signed URL to view/download a file. Public endpoint.',
        auth: 'Public endpoint',
        response: 'Redirects to signed GCP URL',
        example: `curl -X GET https://api.signtada.com/files/uploads/document_20240101_120000.pdf`
      }
    ]
  },
  signing: {
    title: 'Signing',
    description: 'Document signing operations for recipients.',
    endpoints: [
      {
        method: 'POST',
        path: '/signing/sign_document',
        description: 'Sign a document using invitation token. Public endpoint, no user auth required.',
        auth: 'Public endpoint - Uses invitation token',
        requestBody: {
          reference_id: 'ABC12345',
          token: 'invitation-token-uuid',
          signature: 'data:image/png;base64,iVBORw0KGgo...',
          latitude: 37.7749, // Optional
          longitude: -122.4194, // Optional
          face_image: 'data:image/jpeg;base64,/9j/4AAQ...' // Optional
        },
        response: {
          message: 'Document signed successfully',
          signed_pdf: 'https://storage.googleapis.com/...'
        },
        example: `curl -X POST https://api.signtada.com/signing/sign_document \\
  -H "Content-Type: application/json" \\
  -d '{
    "reference_id": "ABC12345",
    "token": "invitation-token-uuid",
    "signature": "data:image/png;base64,iVBORw0KGgo..."
  }'`,
        errors: [
          {
            status: 402,
            message: 'Organization signature quota exceeded. Please contact the sender to resolve this.',
            description: 'Insufficient credits'
          }
        ]
      },
      {
        method: 'POST',
        path: '/signing/reject_document',
        description: 'Reject a document signing request.',
        auth: 'Public endpoint - Uses invitation token',
        requestBody: {
          reference_id: 'ABC12345',
          token: 'invitation-token-uuid',
          reason: 'I do not agree with the terms'
        },
        response: {
          message: 'Document rejected successfully'
        },
        example: `curl -X POST https://api.signtada.com/signing/reject_document \\
  -H "Content-Type: application/json" \\
  -d '{
    "reference_id": "ABC12345",
    "token": "invitation-token-uuid",
    "reason": "I do not agree with the terms"
  }'`
      },
      {
        method: 'GET',
        path: '/signing/download_audit/<reference_id>',
        description: 'Download legal audit trail PDF. Public endpoint.',
        auth: 'Public endpoint',
        response: 'PDF file download',
        example: `curl -X GET https://api.signtada.com/signing/download_audit/ABC12345 \\
  -o audit_trail.pdf`
      }
    ]
  },
  users: {
    title: 'Users',
    description: 'User management. Admin and Super Admin only.',
    endpoints: [
      {
        method: 'GET',
        path: '/users',
        description: 'List users. Super Admin sees all, Admin sees only their company users.',
        auth: 'Protected - Requires Bearer token with ADMIN or SUPER_ADMIN role',
        queryParams: [
          {
            name: 'companyId',
            type: 'string',
            required: false,
            description: 'Filter by company ID (Super Admin only)'
          }
        ],
        response: {
          users: [
            {
              id: '507f1f77bcf86cd799439011',
              email: 'user@example.com',
              roles: ['USER'],
              companyId: '507f1f77bcf86cd799439011',
              isActive: true
            }
          ]
        },
        example: `curl -X GET https://api.signtada.com/users \\
  -H "Authorization: Bearer <admin_token>"`
      },
      {
        method: 'POST',
        path: '/users',
        description: 'Create a new user.',
        auth: 'Protected - Requires Bearer token with ADMIN or SUPER_ADMIN role',
        requestBody: {
          email: 'newuser@example.com',
          password: 'securepassword123',
          roles: ['USER'],
          companyId: '507f1f77bcf86cd799439011'
        },
        response: {
          message: 'User created successfully',
          user: {
            id: '507f1f77bcf86cd799439011',
            email: 'newuser@example.com',
            roles: ['USER']
          }
        },
        example: `curl -X POST https://api.signtada.com/users \\
  -H "Authorization: Bearer <admin_token>" \\
  -H "Content-Type: application/json" \\
  -d '{
    "email": "newuser@example.com",
    "password": "securepassword123",
    "roles": ["USER"],
    "companyId": "507f1f77bcf86cd799439011"
  }'`
      },
      {
        method: 'PUT',
        path: '/users/<user_id>',
        description: 'Update user details.',
        auth: 'Protected - Requires Bearer token with ADMIN or SUPER_ADMIN role',
        requestBody: {
          email: 'updated@example.com',
          roles: ['USER'],
          isActive: true
        },
        response: {
          message: 'User updated successfully',
          user: {}
        },
        example: `curl -X PUT https://api.signtada.com/users/507f1f77bcf86cd799439011 \\
  -H "Authorization: Bearer <admin_token>" \\
  -H "Content-Type: application/json" \\
  -d '{"email": "updated@example.com"}'`
      },
      {
        method: 'DELETE',
        path: '/users/<user_id>',
        description: 'Soft delete a user (sets isActive to false).',
        auth: 'Protected - Requires Bearer token with ADMIN or SUPER_ADMIN role',
        response: {
          message: 'User deleted successfully'
        },
        example: `curl -X DELETE https://api.signtada.com/users/507f1f77bcf86cd799439011 \\
  -H "Authorization: Bearer <admin_token>"`
      }
    ]
  },
  otp: {
    title: 'OTP',
    description: 'Send and verify one-time passwords for signing (when OTP is enabled on a document request).',
    endpoints: [
      {
        method: 'POST',
        path: '/otp/send',
        description: 'Send OTP to recipient for signing. Only applicable when the document has otp_enabled in security_settings.',
        auth: 'Public - Uses reference_id and recipient token (sign_link)',
        requestBody: {
          reference_id: 'ABC12345',
          token: 'invitation-token-uuid'
        },
        requestBodySchema: {
          reference_id: {
            type: 'string',
            required: true,
            description: 'Document reference ID'
          },
          token: {
            type: 'string',
            required: true,
            description: 'Recipient sign_link token from the signing invitation'
          }
        },
        response: {
          message: 'OTP sent successfully'
        },
        example: `curl -X POST https://api.signtada.com/otp/send \\
  -H "Content-Type: application/json" \\
  -d '{"reference_id": "ABC12345", "token": "invitation-token-uuid"}'`,
        errors: [
          { status: 404, message: 'Request not found', description: 'Invalid reference_id' },
          { status: 401, message: 'Unauthorized', description: 'Invalid token for recipient' },
          { status: 200, message: 'OTP not required for this document', description: 'Document has otp_enabled false' }
        ]
      },
      {
        method: 'POST',
        path: '/otp/verify',
        description: 'Verify OTP code before completing signature. Called from the signing flow when OTP is required.',
        auth: 'Public',
        requestBody: {
          email: 'recipient@example.com',
          reference_id: 'ABC12345',
          otp: '123456'
        },
        requestBodySchema: {
          email: { type: 'string', required: true, description: 'Recipient email' },
          reference_id: { type: 'string', required: true, description: 'Document reference ID' },
          otp: { type: 'string', required: true, description: 'OTP code received by recipient' }
        },
        response: {
          success: true,
          message: 'OTP Verified'
        },
        example: `curl -X POST https://api.signtada.com/otp/verify \\
  -H "Content-Type: application/json" \\
  -d '{"email": "recipient@example.com", "reference_id": "ABC12345", "otp": "123456"}'`,
        errors: [
          { status: 400, message: 'Invalid or expired OTP', description: 'success: false in response' }
        ]
      }
    ]
  },
  branding: {
    title: 'Branding',
    description: 'Organization-level white-label branding (logo, theme, colors). Editable by ADMIN and SUPER_ADMIN only.',
    endpoints: [
      {
        method: 'GET',
        path: '/branding',
        description: 'Get branding for the current user\'s organization. Super Admin can pass orgId query to get another org.',
        auth: 'Protected - Requires Bearer token (ADMIN or SUPER_ADMIN for update; any authenticated user can GET)',
        queryParams: [
          {
            name: 'orgId',
            type: 'string',
            required: false,
            description: 'Organization ID (Super Admin only; otherwise uses user\'s company)'
          }
        ],
        response: {
          product_name: 'SignTada',
          logo_url: null,
          theme: 'default',
          primary_color: '#FFD600',
          accent_color: '#FFAB00',
          show_powered_by: true,
          first_part_color: null,
          rest_part_color: null,
          custom_themes: []
        },
        example: `curl -X GET "https://api.signtada.com/branding" \\
  -H "Authorization: Bearer <access_token>"`
      },
      {
        method: 'GET',
        path: '/branding/public',
        description: 'Get branding by organization ID. Public endpoint used by the signing page so signers see the correct logo/theme without logging in.',
        auth: 'Public',
        queryParams: [
          {
            name: 'orgId',
            type: 'string',
            required: false,
            description: 'Organization ID (if omitted, returns default branding)'
          }
        ],
        response: {
          product_name: 'SignTada',
          logo_url: null,
          theme: 'default',
          primary_color: '#FFD600',
          accent_color: '#FFAB00',
          show_powered_by: true,
          first_part_color: null,
          rest_part_color: null,
          custom_themes: []
        },
        example: `curl -X GET "https://api.signtada.com/branding/public?orgId=507f1f77bcf86cd799439011"`
      },
      {
        method: 'POST',
        path: '/branding/update',
        description: 'Update branding for the resolved organization. ADMIN can update own org; SUPER_ADMIN can pass orgId in body or query.',
        auth: 'Protected - Requires Bearer token with ADMIN or SUPER_ADMIN role',
        requestBody: {
          product_name: 'My Product',
          logo_url: 'https://example.com/logo.png',
          theme: 'ocean',
          primary_color: '#FFD600',
          accent_color: '#FFAB00',
          show_powered_by: true,
          first_part_color: '#ffffff',
          rest_part_color: '#FFD600',
          custom_themes: [
            { name: 'Custom', primary_color: '#FFD600', accent_color: '#FFAB00' }
          ],
          orgId: '507f1f77bcf86cd799439011'
        },
        response: {
          message: 'Branding updated successfully',
          branding: {}
        },
        example: `curl -X POST https://api.signtada.com/branding/update \\
  -H "Authorization: Bearer <access_token>" \\
  -H "Content-Type: application/json" \\
  -d '{"product_name": "My Product", "theme": "ocean", "primary_color": "#FFD600"}'`,
        errors: [
          { status: 400, message: 'primary_color must be a valid hex color (e.g. #FFD600)', description: 'Invalid hex' },
          { status: 403, message: 'Forbidden – cannot access other organization', description: 'ADMIN passing another orgId' },
          { status: 404, message: 'Organization not found', description: 'Invalid orgId' }
        ]
      }
    ]
  }
};

export default APIEndpoints;
